export default {
  props: {
    optionsData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    focus: {
      type: Boolean,
      default: true,
    },
    enterFunc: {
      type: Function,
      default: () => {},
    },
    fileInfo: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
    formData: {
      type: Object,
      default: () => {
        return {
          title: "",
          icon: "",
          label: "",
          name: "",
        };
      },
    },
  },
  data() {
    return {
      id: this.$options.name,
    };
  },
  watch: {
    focus() {},
    formData() {},
    optionsData() {},
  },
};
